import MSwitchWithText from './MSwitchWithText';
export default MSwitchWithText;
